var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChevron = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 10 7"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5 4.525 8.652.74a.77.77 0 0 1 1.117 0 .84.84 0 0 1 0 1.157L5.559 6.26a.77.77 0 0 1-1.117 0L.232 1.897a.84.84 0 0 1 0-1.157.77.77 0 0 1 1.116 0L5 4.525Z"
})));
export { SvgChevron as ReactComponent };
export default __webpack_public_path__ + "assets/media/chevron.301fb7866b54f798f9bcef41d0e9f72a.svg";